var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.89841 17.5014C4.04324 17.3551 4.24239 17.2698 4.4536 17.2698H23.6077C23.9578 17.2698 24.1328 17.6965 23.8853 17.9464L20.1016 21.7684C19.9567 21.9147 19.7576 22 19.5464 22H0.392251C0.0422387 22 -0.132768 21.5733 0.114655 21.3234L3.89841 17.5014Z",
    fill: "url(#paint0_linear_475_603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89841 3.23163C4.04928 3.08534 4.24842 3 4.4536 3H23.6077C23.9578 3 24.1328 3.42669 23.8853 3.67661L20.1016 7.49856C19.9567 7.64485 19.7576 7.73019 19.5464 7.73019H0.392251C0.0422387 7.73019 -0.132768 7.3035 0.114655 7.05358L3.89841 3.23163Z",
    fill: "url(#paint1_linear_475_603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1016 10.3208C19.9567 10.1745 19.7576 10.0892 19.5464 10.0892H0.392251C0.0422387 10.0892 -0.132768 10.5159 0.114655 10.7658L3.89841 14.5878C4.04324 14.7341 4.24239 14.8194 4.4536 14.8194H23.6077C23.9578 14.8194 24.1328 14.3927 23.8853 14.1428L20.1016 10.3208Z",
    fill: "url(#paint2_linear_475_603)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_475_603",
    x1: 21.778,
    y1: 0.716868,
    x2: 8.31136,
    y2: 26.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_475_603",
    x1: 15.9816,
    y1: -2.33983,
    x2: 2.51504,
    y2: 23.1964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_475_603",
    x1: 18.8614,
    y1: -0.821195,
    x2: 5.39475,
    y2: 24.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolana);
export default __webpack_public_path__ + "static/media/icon-solana.f2013f9a8b754c77e6b730a8aed67839.svg";
export { ForwardRef as ReactComponent };